export type TranslationKeys = {
  [p: string]: string | TranslationKeys;
};

export type TranslationModel = {
  lang: string;
  data: TranslationKeys;
};
